export const SEARCH_REQUESTING = 'SEARCH_REQUESTING'
export const SEARCH_REQUESTING_ALERTE = 'SEARCH_REQUESTING_ALERTE'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_FAILED = 'SEARCH_FAILED'
export const SEARCH_EMPTY = 'SEARCH_EMPTY'

// Nouvelles constantes pour la vérification de crédit
export const CHECK_CREDIT_REQUESTING = 'CHECK_CREDIT_REQUESTING'
export const CHECK_CREDIT_SUCCESS = 'CHECK_CREDIT_SUCCESS'
export const CHECK_CREDIT_FAILED = 'CHECK_CREDIT_FAILED'
export const CHECK_CREDIT_INSUFFICIENT = 'CHECK_CREDIT_INSUFFICIENT'
export const RESET_CREDIT_STATUS = 'RESET_CREDIT_STATUS'

export const SEARCH_DETAIL_REQUESTING = 'SEARCH_DETAIL_REQUESTING'
export const SEARCH_DETAIL_SUCCESS = 'SEARCH_DETAIL_SUCCESS'
export const SEARCH_DETAIL_FAILED = 'SEARCH_DETAIL_FAILED'
export const RESET_SEARCH_DETAIL_STATE = 'RESET_SEARCH_DETAIL_STATE'

//Decision pour le demandeur
export const SEARCH_DECISION_APPLICANTS_REQUESTING = 'SEARCH_DECISION_APPLICANTS_REQUESTING'
export const SEARCH_DECISION_APPLICANTS_SUCCESS = 'SEARCH_DECISION_APPLICANTS_SUCCESS'
export const SEARCH_DECISION_APPLICANTS_FAILED = 'SEARCH_DECISION_APPLICANTS_FAILED'
export const PAGINATE_SEARCH_DECISION_APPLICANTS_REQUESTING = 'PAGINATE_SEARCH_DECISION_APPLICANTS_REQUESTING'
export const PAGINATE_SEARCH_DECISION_APPLICANTS_SUCCESS = 'PAGINATE_SEARCH_DECISION_APPLICANTS_SUCCESS'
export const PAGINATE_SEARCH_DECISION_APPLICANTS_FAILED = 'PAGINATE_SEARCH_DECISION_APPLICANTS_FAILED'

//Decision pour le defendeur
export const SEARCH_DECISION_DEFENDANTS_REQUESTING = 'SEARCH_DECISION_DEFENDANTS_REQUESTING'
export const SEARCH_DECISION_DEFENDANTS_SUCCESS = 'SEARCH_DECISION_DEFENDANTS_SUCCESS'
export const SEARCH_DECISION_DEFENDANTS_FAILED = 'SEARCH_DECISION_DEFENDANTS_FAILED'
export const PAGINATE_SEARCH_DECISION_DEFENDANTS_REQUESTING = 'PAGINATE_SEARCH_DECISION_DEFENDANTS_REQUESTING'
export const PAGINATE_SEARCH_DECISION_DEFENDANTS_SUCCESS = 'PAGINATE_SEARCH_DECISION_DEFENDANTS_SUCCESS'
export const PAGINATE_SEARCH_DECISION_DEFENDANTS_FAILED = 'PAGINATE_SEARCH_DECISION_DEFENDANTS_FAILED'

//Autre decision pour le demandeur
export const SEARCH_OTHERS_APPLICANTS_REQUESTING = 'SEARCH_OTHERS_APPLICANTS_REQUESTING'
export const SEARCH_OTHERS_APPLICANTS_SUCCESS = 'SEARCH_OTHERS_APPLICANTS_SUCCESS'
export const SEARCH_OTHERS_APPLICANTS_FAILED = 'SEARCH_OTHERS_APPLICANTS_FAILED'
export const PAGINATE_SEARCH_OTHERS_APPLICANTS_REQUESTING = 'PAGINATE_SEARCH_OTHERS_APPLICANTS_REQUESTING'
export const PAGINATE_SEARCH_OTHERS_APPLICANTS_SUCCESS = 'PAGINATE_SEARCH_OTHERS_APPLICANTS_SUCCESS'
export const PAGINATE_SEARCH_OTHERS_APPLICANTS_FAILED = 'PAGINATE_SEARCH_OTHERS_APPLICANTS_FAILED'

//Autre decision pour le defedant
export const SEARCH_OTHERS_DEFENDANTS_REQUESTING = 'SEARCH_OTHERS_DEFENDANTS_REQUESTING'
export const SEARCH_OTHERS_DEFENDANTS_SUCCESS = 'SEARCH_OTHERS_DEFENDANTS_SUCCESS'
export const SEARCH_OTHERS_DEFENDANTS_FAILED = 'SEARCH_OTHERS_DEFENDANTS_FAILED'
export const PAGINATE_SEARCH_OTHERS_DEFENDANTS_REQUESTING = 'PAGINATE_SEARCH_OTHERS_DEFENDANTS_REQUESTING'
export const PAGINATE_SEARCH_OTHERS_DEFENDANTS_SUCCESS = 'PAGINATE_SEARCH_OTHERS_DEFENDANTS_SUCCESS'
export const PAGINATE_SEARCH_OTHERS_DEFENDANTS_FAILED = 'PAGINATE_SEARCH_OTHERS_DEFENDANTS_FAILED'



export const SEARCH_DETAIL_DIRIGEANTS_REQUESTING = 'SEARCH_DETAIL_DIRIGEANTS_REQUESTING'
export const SEARCH_DETAIL_DIRIGEANTS_SUCCESS = 'SEARCH_DETAIL_DIRIGEANTS_SUCCESS'
export const SEARCH_DETAIL_DIRIGEANTS_FAILED = 'SEARCH_DETAIL_DIRIGEANTS_FAILED'
export const SEARCH_ADD_TO_CART = 'SEARCH_ADD_TO_CART'
export const SEARCH_REMOVE_FROM_CART = 'SEARCH_REMOVE_FROM_CART'

//Annonces légales
export const SEARCH_ANNONCES_REQUESTING = 'SEARCH_ANNONCES_REQUESTING'
export const SEARCH_ANNONCES_SUCCESS = 'SEARCH_ANNONCES_SUCCESS'
export const SEARCH_ANNONCES_FAILED = 'SEARCH_ANNONCES_FAILED'

//Marchés publics
export const SEARCH_MARCHES_PUBLICS_REQUESTING = 'SEARCH_MARCHES_PUBLICS_REQUESTING'
export const SEARCH_MARCHES_PUBLICS_SUCCESS = 'SEARCH_MARCHES_PUBLICS_SUCCESS'
export const SEARCH_MARCHES_PUBLICS_FAILED = 'SEARCH_MARCHES_PUBLICS_FAILED'

// Pagination Annonces légales
export const PAGINATE_SEARCH_ANNONCES_REQUESTING = 'PAGINATE_SEARCH_ANNONCES_REQUESTING'
export const PAGINATE_SEARCH_ANNONCES_SUCCESS = 'PAGINATE_SEARCH_ANNONCES_SUCCESS'
export const PAGINATE_SEARCH_ANNONCES_FAILED = 'PAGINATE_SEARCH_ANNONCES_FAILED'

// Pagination Marchés publics
export const PAGINATE_SEARCH_MARCHES_PUBLICS_REQUESTING = 'PAGINATE_SEARCH_MARCHES_PUBLICS_REQUESTING'
export const PAGINATE_SEARCH_MARCHES_PUBLICS_SUCCESS = 'PAGINATE_SEARCH_MARCHES_PUBLICS_SUCCESS'
export const PAGINATE_SEARCH_MARCHES_PUBLICS_FAILED = 'PAGINATE_SEARCH_MARCHES_PUBLICS_FAILED'

// Nouvelle API unifiée pour récupérer toutes les entités liées à une entreprise
export const FETCH_COMPANY_ENTITIES_REQUESTING = 'FETCH_COMPANY_ENTITIES_REQUESTING'
export const FETCH_COMPANY_ENTITIES_SUCCESS = 'FETCH_COMPANY_ENTITIES_SUCCESS'
export const FETCH_COMPANY_ENTITIES_FAILED = 'FETCH_COMPANY_ENTITIES_FAILED'